import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';

import CoachListItem from '../CoachListItem';

const List = styled.div`
  padding: 15px;
`;

const CoachList = ({ coachs, onItemClick, clientToken }) => (
  <List>
    {coachs
      .map(coach => <CoachListItem key={coach.id} coach={coach} onClick={onItemClick} clientToken={clientToken} />)
      .filter(coach => !!coach)}
  </List>
);

CoachList.propTypes = {
  coachs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onItemClick: PropTypes.func.isRequired,
  clientToken: PropTypes.string.isRequired
};

export default CoachList;



// WEBPACK FOOTER //
// ./src/components/CoachList/CoachList.jsx